import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { CircularProgressColorType } from "types/extended";

interface CashDCricularProgressPropsType {
  color?: CircularProgressColorType;
  size?: string | number;
}
const CashDCricularProgress: React.FC<CashDCricularProgressPropsType> = ({
  color = "primary",
  size = 30,
}) => {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <CircularProgress color={color} size={size}/>
    </Box>
  );
};

export default React.memo(CashDCricularProgress);
